import { PageShell, AboutSection } from "@/components/sections";

const About = () => (
  <PageShell testId="about-page">
    <AboutSection />
  </PageShell>
);

export default About;
